import {ComponentRef, Directive, Input, ViewContainerRef} from '@angular/core';
import {GeneralService} from '../../services/general.service';

@Directive({
    selector: '[acTableCell]',
})
export class AcTableCellDirective {

    @Input() acTableCell;
    @Input('acTableCellColumn') column;
    @Input('acTableCellFormatter') formatter;
    @Input('acTableCellTemplate') template;

    private _row;
    @Input('acTableCellRow') set row(row: any) {
        this._row = row;
        this.viewContainerRef.clear();
        if (!this.formatter) {
            this.template && this.viewContainerRef.createEmbeddedView(this.template, {row: this._row, col: this.column});
            return;
        }

        const content: string | ComponentRef<any> = this.backwardCompFormatter(this.column, this._row?.data) || '';
        if (typeof content === 'string' || typeof content === 'number') {
            this.acTableCell.innerHTML = content;
        } else {
            this.viewContainerRef.insert(content.hostView);
        }
    }

    constructor(public viewContainerRef: ViewContainerRef) {
    }

    ngOnInit() {
        if (!this._row) {
            this.row = null;
        }
    }

    // REMOVE BACKWARD COMPATIBILITY


    backwardCompFormatter = (col, row) => {
        if (row) {
            return this.formatter({
                getValue: () => GeneralService.byString(row, col.field),
                getData: () => row,
                getField: () => col.field,
            });
        } else {
            return this.formatter(col);
        }
    };
    // END REMOVE BACKWARD COMPATIBILITY
}
